// ReduxSlipSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  slipList: [],
};

const ReduxSlipSlice = createSlice({
  name: "slips",
  initialState,
  reducers: {
    addSlip: (state, action) => {
      state.slipList.push(action.payload);
    },
    deleteSlip: (state, action) => {
      state.slipList = state.slipList.filter(
        (slip, index) => index !== action.payload
      );
    },
    clearSlips: (state) => {
      state.slipList = [];
    },
  },
});

export const { addSlip, deleteSlip, clearSlips } = ReduxSlipSlice.actions;
export default ReduxSlipSlice.reducer;
